module.exports = __webpack_public_path__ + "img/calendar4.d092f8ba.png";